var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Utils
import { debounce } from 'ezyvet-fe-helpers';
import { searchResolvedAction } from './searchResolvedAction';
/**
 * Delays the retrieval and persistence of dropdown options to allow a
 * user to type what they want before a request occurs.
 * On success, menu will automatically open and the first result will be
 * highlighted.
 * If there is only 1 result then that result will automatically be selected
 *
 * This function currently does things that attempt to replicate the functionality of
 * the original dropdown in ezyvet using react-select.
 * This includes:
 * - Automatically selecting the dropdown option result if there is only 1 result
 * - Showing the single dropdown option if the selected result is returned as a result (it is not autoselected)
 * - Selected dropdown option should always be at the end of the dropdown option list (effectively
 *   showing it at the bottom of the dropdown menu)
 * - If we have a selected dropdown, and we search and receive a single result, we should set the result and the
 *   current selected dropdown (total of 2 dropdown options)
 *
 * @param {(dropdownOptions: DropdownOption[]) => DropdownOption[]} formatDropdownOptions
 * @param {(value: string) => Promise<DropdownOption[]>} getDropdownOptions
 * @param {Dispatch<DropdownReducerAction>} dispatch
 * @param {(dropdownOption: DropdownOption) => void} handleSelectOption
 */
export var generateFetchAndSetDropdownOptionsDebounced = function (currentDropdownOptionSelected, formatDropdownOptions, getDropdownOptions, dispatch, handleSelectOption) {
    return function (delay) {
        return debounce(function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var fetchedDropdownOptions, newDropdownOptions, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getDropdownOptions(value)];
                    case 1:
                        fetchedDropdownOptions = _a.sent();
                        newDropdownOptions = formatDropdownOptions(fetchedDropdownOptions);
                        // Persist the dropdown options (if this is an empty array then it is okay)
                        !currentDropdownOptionSelected && (newDropdownOptions === null || newDropdownOptions === void 0 ? void 0 : newDropdownOptions.length) === 1
                            ? handleSelectOption(fetchedDropdownOptions[0])
                            : dispatch(searchResolvedAction(fetchedDropdownOptions));
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        dispatch(searchResolvedAction([]));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, delay);
    };
};
//# sourceMappingURL=generateFetchAndSetDropdownOptionsDebounced.js.map